import React from 'react'

export default function Spacer({className}:{className?:string}) {
  return (
    <div className={`m-2 ${className}`} />
  )
}
